<template>
  <ul class="m-news list-unstyled">
    <li class="m-news__item" v-for="news in newsCollection">
      <router-link :to="{name: 'ReadNews', params: { id: news.id }}">{{ news.title }}</router-link>
    </li>
  </ul>
</template>

<script>
import { BackendApi } from '@/services/backend_api'

export default {
  name: 'News',
  data () {
    return {
      newsCollection: []
    }
  },
  created () {
    BackendApi.getAnonymousClient().get('news/?limit=0&orderBy=dateTime&orderDirection=desc')
      .then(r => {
        this.newsCollection = r.data
      })
  }
}
</script>



// WEBPACK FOOTER //
// News.vue?7e96d100